/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import IncidentContainer from './incident/container/IncidentContainer'
import Covid19Container from './covid-19/container/Covid19Container'
// import SettingsContainer from './settings/SettingsContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';

function EHelpContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">E-Help</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW OHP DASHBOARD']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/e-help"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW OHP TRANSACTIONS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/e-help/incident"
          >
            Incident
          </NavLink>
        )}
        {Acl(permissions, ['VIEW OHP TRANSACTIONS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/e-help/covid-19"
          >
            Covid-19 Vaccine 
          </NavLink>
        )}
      </div>
      <Switch>  
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        <Route path={`${match.path}/incident`} component={IncidentContainer} />
        <Route path={`${match.path}/covid-19`} component={Covid19Container} />
        {/* <Route path={`${match.path}/covid-19`} component={SettingsContainer} /> */}
      </Switch>
    </div>
  );
}

EHelpContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(EHelpContainer);


// TODO: replace ACL permission